/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demopsychologie15Inputs */

const en__field_enum_demopsychologie15 = /** @type {(inputs: _Field_Enum_Demopsychologie15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05 - Psychologie und Sportwissenschaften`)
};

const de__field_enum_demopsychologie15 = /** @type {(inputs: _Field_Enum_Demopsychologie15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05 - Psychologie und Sportwissenschaften`)
};

/**
* | output |
* | --- |
* | "05 - Psychologie und Sportwissenschaften" |
*
* @param {_Field_Enum_Demopsychologie15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demopsychologie15 = /** @type {((inputs?: _Field_Enum_Demopsychologie15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demopsychologie15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demopsychologie15(inputs)
	return de__field_enum_demopsychologie15(inputs)
});
export { _field_enum_demopsychologie15 as "_field_enum_DEMOPSYCHOLOGIE" }